'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  exam: {
    practice: 'རང་བདག་གི་གཤར་སྦྱང། ',
    notRegister: 'མ་མིང་ཐོ་འགོད་པ། ',
    examHours: 'དུས་རིང། ',
    reRegistration: 'ཕྱིར་འཐེན་བྱ་རྒྱུ་འི་ཐོ་འགོད། ',
    prevPrevious: 'སྟེང་གི་གནད་དོན་ལ། ',
    accuracy: '正确率། ',
    reviewAudit: 'ཞིབ་བཤེར་ཁྲོད། ',
    participant: 'མིང་ཐོ་འགོད་པ། ',
    wrongQuestion: 'ནོར་ཁ་བྱང་། ',
    auditNoPass: 'ཞིབ་བཤེར་གཏན་འབེབས་མ་བྱས་པར་བརྟེན་ནས། ',
    involvement: 'དེ་ཞུགས་པ། ',
    submitAnswers: 'ཕུལ་བའི་ལན། ',
    continuePracticed: 'མུ་མཐུད་གཤར་སྦྱང། ',
    examination: 'ཐོ་འགོད་ཡིག་རྒྱུགས། ',
    toFavorite: 'འཛམ་གླིང་བསྡུ་ཉར། ',
    knowledgeCompetition: 'ཤེས་བྱ་འི་འགྲན་བསྡུར། ',
    questionsAnalysis: 'རྒྱུགས་གཞི་དབྱེ་ཞིབ། ',
    noInvolvement: 'ཞུགས་མེད་པ་འི། ',
    answerWarning: 'ཐེངས་འདི་འི་རྒྱུགས་ལེན་ཁ་བྱང་དེ་གཅིག་པུ་འི་འདྲི་གཞི་མི་ལྡོག་པ། འོག་གནད་དོན་གོང་ཞུ་གཟབ་ནན། ',
    problemPoints: 'ཁ་བྱང་ཙམ་གྱིས་དབྱེ་ཞིབ། ',
    searchExamPractice: 'བཤེར་འཚོལ་ཁྱོད་ལ་སྤྲོ་སྣང་རྒྱུགས་ལེན་དང་གཤར་སྦྱང། ',
    topics: 'ཁ་བྱང། ',
    nextPrevious: 'འོག་གི་གནད་དོན་ལ། ',
    participanted: 'སྔར་ཡོད་ཀྱི་ཐོ་འགོད། ',
    startPractice: 'ཐོག་མར་གཤར་སྦྱང། ',
    inputAnswerTips: 'ཁྱེད་ཀྱི་ཚད་ཁྱེད་ལ་དྲིས་ལན། ',
    yourAnswers: 'ཁྱོད་ཀྱི་ལན། ',
    rightAnswers: 'ལན་ཡང་དག་པ། ',
    noAnalysis: 'གནས་སྐབས་མེད་པའི་དབྱེ་ཞིབ།',
    registration: 'ཐོ་འགོད་ལེགས་གྲུབ། ',
    examTime: 'རྒྱུགས་ལེན་པའི་དུས་ཚོད། ',
    practiced: 'སྔར་ཡོད་ཀྱི་གཤར་སྦྱང། ',
    noPassingTheExam: 'ཆེས་ཕངས་སེམས་མེད་པས་ཁྱེད་རང་གིས་ཐེངས་འདིའི་རྒྱུགས་',
    commitSuccess: 'འབུལ་སྤྲོད།',
    passingTheExam: 'ཁྱེད་རང་གིས་ཐེངས་འདིའི་ཡིག་རྒྱུགས་ལ་གྲོས་འཆམ་བྱུང་བ་རེད།'
  },
  play: {
    chapter: 'ལེའུ། ',
    note: 'ཟིན་བྲིས། ',
    chapterText1: 'དོན་ཚན། ',
    closeOrNot: 'ཡིན་མིན་སྒོ་རྒྱག་མིག་སྔ་འི་སྐར་ཁུང། ',
    notShowAgain: 'མི་འི་སྣེ་སྟོན་དེའི་ཆ་འཕྲིན། ',
    gotIt: 'ང་ས་ཤེས་ཐལ། ',
    evaluateStar: 'སྐར་མ། ',
    noteBlockTitle: 'ཟིན་བྲིས། ',
    chapterText2: 'ལེའུ། ',
    closeTips: 'མ་ལག་སྲིད་ཉར་འཛིན་ཁྱེད་ཀྱི་སྒྲུབ་པའི་བཟོ་བཅོས།',
    tips: 'དྲོད་སྐྱིད་ཀྱི་སྣེ་སྟོན། ',
    autoStopTips: 'ཁྱོད་ལ་དུས་ཡུན་མའི་བཀོད་འདོམས་མ་ལག་རང་འགུལ་མཚམས་བཞག་བརྙན་འཕྲིན་བསྟན་པ། ',
    autoStop: 'རང་འགུལ་གྱིས་མཚམས་བསྟན་པ། ',
    noCoursePlay: 'མིག་སྔ་འི་སློབ་ཚན་ཁྲོད་ན་འགྲིག་ལ་བསྟན་པའི་སློབ་ཚན་ཁག། ',
    closeButton: 'བྲལ། ',
    jump: 'མཆོང་འདས།',
    playTips: 'འགན་ལེན་ཁྱེད་ཀྱིས་སློབ་སྦྱོང་བྱེད་པའི་དུས་ཚོད་ནི་མ་ལག་གི་རྒྱུན་ལྡན་གྱི་ཟིན་ཐོ་ཁྱེད་ཀྱིས་དེ་མཚུངས་གཡས་སྟེང་རྭ་“མཇུག་བསྒྲིལ་སློབ་སྦྱོང་”གཅུས་སྒོ་ཕྱིར་འཐེན་སློབ་སྦྱོང་གལ་ཏེ་ཐད་ཀར་སྒོ་རྒྱག་ལྟ་ཆསཁྱེད་ཀྱི་སློབ་སྦྱོང་གི་དུས་ཚོད་སྲིད་པར་གྱུར་ལ་རྒྱུན་ལྡན་གྱི་ཟིན་ཐོ། ',
    saveEvaluate: 'འབུལ། ',
    notePlaceholder: 'ཁྱེད་ཀྱི་ཚད་ཟིན་ཐོ། ',
    confirmOut: 'ཁྱེད་ཀྱིས་གཏན་ཁེལ་ཕྱིར་འཐེན་བསྟན་པ་ཨེ། ',
    evaluate: 'གདེང་འཇོག། ',
    endStudy: 'མཇུག་བསྒྲིལ་སློབ་སྦྱོང། ',
    attention: 'ཡིད་འཇོག་ཞུ།'
  },
  questionnaire: {
    shortQuestion: 'བསྡུས་བརྗོད་ཀྱི་གྲུབ་ཚུལ། ',
    newLine: 'གསར་སྣོན་བྱས་པའི་བྱ་སྤྱོད། ',
    topics: 'ཁ་བྱང། ',
    submitTips: 'ཁྱེད་ནི་ལེགས་འགྲུབ་འབུལ་ཤོག་ས་ཁྱོད་ཀྱིས་ཞུགས་པ།',
    save: 'ཉར་འཛིན། ',
    multiple: 'མང་དཔྱད་གཞི། ',
    description: 'དྲི་ཤོག་གསལ་བཤད། ',
    sort: 'རིམ་རྟགས། ',
    handed: 'རྒྱུགས་ཡིག་སྤྲོད་པ།',
    tableQuestions: 'རེའུ་མིག་འབྲི། ',
    printing: 'ཐེལ་ཙེ་རྒྱག་པ། ',
    content: 'ནང་དོན། ',
    inputContent: 'ཁྱེད་ཀྱི་ཚད་ལན་འདེབསནང་དོན། ',
    submitSuccess: 'འབུལ་ལེགས་གྲུབ། ',
    single: 'གཅིག་པུ་ར་དཔྱད་གཞི། ',
    examList: 'རྒྱུགས་གཞི་རེའུ་མིག་བཀོད། ',
    deleteLine: 'སུབ་པ་བྱ་སྤྱོད། ',
    saveSuccess: 'ཉར་འཛིན་ལེགས་གྲུབ། ',
    notParticipat: 'ཞུགས་མེད་པ་འི། ',
    closePage: 'སྒོ་རྒྱག་འདིའི་ཤོག་ངོས། ',
    export: 'སྣེ་ཁྲིད་དགོས་པ།'
  },
  index: {
    userInfo: 'མི་སྒེར་གྱི་ལྟེ་གནས། ',
    operateConfig: 'དེའི་བཀོལ་སྤྱོད་བྱ་ཡུལ་ལྟ་ཆསདང་ལེན་མི་བྱེད་པ། གལ་ཏེ་འདོད་སྤྱོད་འགོ་ཚུགས་དེའི་ནུས་པར་ཁྱོད་ཀྱིས་ས་གནས་ཀྱི་ལན་ཀན་ནང་ནས་ནང་འདྲེན། About། config། རེ་རེ་ཡི་signed.applets.codebase_principal_supportལས་རེས་དེའི་ཆེད་དུ་true། ',
    ExitSystem: 'ཕྱིར་འཐེན་དེའི་ཁོངས་གཏོགས་ཀྱི།',
    continueStudy: 'མུ་མཐུད་སློབ་སྦྱོང།',
    uploadError: 'ཡར་འཁོརཕམ་ཁ། ',
    homePage: 'ཤོག་ལྷེ་དང་པོ། ',
    studentRanking: 'སློབ་མ་མིང་ཐོ་གྲལ་བསྒྲིགས་ནས།',
    required: 'ཐེངས་འདི་ར་འབྲི། ',
    faceHours: 'གདོང་འཕྲདསློབ་ཁྲིད་དུས་ཡུན། ',
    recommendCourse: 'འོས་སྦྱོར་སློབ་ཚན།',
    checkAllNotice: 'གཟིགས་ཞིབ་ཡོངས་རྫོགས། ',
    startStudy: 'ཐོག་མར་སློབ་སྦྱོང། ',
    coverImage: 'མདུན་ཤོག་གི་པར་རིས།',
    onlineHours: 'དེ་ན་སློབ་ཁྲིད་དུས་ཡུན། ',
    coursesRanking: '选课མིང་ཐོ་གྲལ་བསྒྲིགས་ནས།',
    faceCourse: 'གདོང་འཕྲདགསོ་སྦྱོང་འཛིན་གྲྭ། ',
    requiredCourses: 'ངེས་སྤྱོང་སློབ་ཚན།',
    wecome: 'དགའ་བསུ་ཁྱེད།',
    hotCourse: 'དྲོ་བའི་སློབ་ཚན། ',
    favoriteTips: 'རྐྱེན་གྱིས་360ལྟ་ཆསནུས་པ་ཚོད་འཛིན་ཞུ་ལྟར། Ctrl+D手动བསྡུ་ཉར་བྱས་པ་རེད། ',
    currentHead: 'མིག་སྔ་འི་མགོ་བརྙན།',
    telephone: 'བློ་འདྲི་འི་ཁ་པར། ',
    noMessage: 'གནས་སྐབས་མེད་པའི་གཞི་གྲངས། ',
    backToTopButton: 'ཕྱིར་ལོག་པའི་གཙུག་ཏུ།',
    fullScreen: 'མངོན་པ། ',
    examPractice: 'རྒྱུགས་ལེན་གཤར་སྦྱང།',
    autoFavorite: 'ཁྱེད་ཀྱི་ལྟ་ཆསམི་བྱེད་པར་རྒྱབ་སྐྱོར། ཁྱོད་ལྟར། Ctrl+D手动བསྡུ་ཉར། ',
    newCourse: 'ཆེས་གསར་བའི་སློབ་ཚན། ',
    currentUser: 'མིག་སྔར་སྤྱོད་མཁན།',
    trainingTime: 'གསོ་སྦྱོང་གི་དུས་ཚོད། ',
    setAsHomePage: 'བཙུགས་པ་དེ་ཤོག་ལྷེ་དང་པོ། ',
    currentPhone: 'མིག་སྔ་འི་ལག་ཐོགས་ཁ་པར། ',
    SystemMessage: 'མ་ལག་དྲན་སྐུལ། ',
    Help: 'རོགས་རམ་ལྟེ་གནས། ',
    encryPhone: 'གསང་སྔགས་འགན་བཅོལ་ལག་ཐོགས་ཁ་པར།',
    backToTop: 'ཕྱིར་ལོག་པའི་གཙུག་ཏུ། ',
    back: 'ཕྱིར། ',
    courseCategory: 'སློབ་ཚན་རིགས་འབྱེད་པ་འི། ',
    head: 'མགོ་བརྙན། ',
    emptyMessage: 'སྟོང་པ། ',
    userHead: 'མིག་སྔར་སྤྱོད་མཁན།',
    top: 'གཙུག་ཏུ། ',
    allCourses: 'ཡོངས་རྫོགས་སློབ་ཚན། ',
    checkAllMessage: 'གཟིགས་ཞིབ་ཡོངས་རྫོགས། ',
    course: 'སློབ་ཚན་སློབ་སྦྱོང། ',
    onlineCourse: 'དྲ་ཐོག་ཆེད་དོན་འཛིན་གྲྭ། ',
    dataDownLoad: 'རྒྱུགས་ལེན་གཤར་སྦྱང། ',
    coursehours: 'སློབ་ཁྲིད་དུས་ཡུན།',
    human: 'མི། ',
    notice: 'བརྡ་ཐོ་ཁྱབ་བསྒྲགས།',
    Administration: 'དོ་དམ་བྱེད་བཞིན་ཡོད།',
    change: 'བཟོ་བཅོས། ',
    message: 'གསར་འགྱུར།',
    userName: 'སྤྱོད་མཁན་མིང་། ',
    autoSetHomeTips: 'ཁྱེད་ཀྱི་ལྟ་ཆསམི་བྱེད་པར་རྒྱབ་སྐྱོར་བྱེད་པའི་རང་འགུལ་རང་འགུལ་གྱིས་བཀོད་སྒྲིག་ཤོག་ལྷེ་དང་པོ། ཁྱེད་བཀོལ་སྤྱོད་བཤར་ལྟ་ཆས་ཀྱི་ཁ་ཏ་ལག་བརྡབཙུགས། ',
    examIsOver: 'དཔྱད་ཞིབ་ལེགས་འགྲུབ་བྱུང། ',
    impotentCourse: 'གཙོ་གནད་སློབ་ཚན། ',
    electiveCourses: 'སྦྱོང་བསླབ་ཚན། ',
    addCollection: 'འཛམ་གླིང་བསྡུ་ཉར་རྙི། ',
    to: 'ནས།',
    accountPassword: 'ཐོ་ཁོངས་ཨང་ཡིག།'
  },
  course: {
    courseYear: 'ལོ། ',
    examLog: 'རྒྱུགས་ལེན་ཟིན་ཐོ། ',
    noDesc: 'གནས་སྐབས་མེད་མཚམས་སྦྱོར་མདོར་བསྡུས། ',
    noPublicExam: 'ཐེངས་འདི་འི་རྒྱུགས་ལེན་པའི་ཁྱབ་བསྒྲགས་མི། ',
    coursesCategory: 'སློབ་ཚན་རིགས་འབྱེད་པ་འི། ',
    checkLog: 'བསྐྱར་དུ་རྒྱུགས་ལེན། ',
    viewPaper: 'གཟིགས་ཞིབ་རྒྱུགས་ཤོག། ',
    newComment: 'ཆེས་གསར་བ་འི། ',
    emptyCommentTips: 'དཔྱད་གཏམ་བརྗོད་པའི་ནང་དོན་དེ་སྟོང། ',
    continueStudy: 'མུ་མཐུད་སློབ་སྦྱོང། ',
    courseData: 'སློབ་ཚན་དཔྱད་གཞི། ',
    donwButton: 'ཁ་། ',
    relatedCourses: 'འབྲེལ་ཡོད་སློབ་ཚན། ',
    score: 'སྐར་མ། ',
    startStudy: 'ཐོག་མར་སློབ་སྦྱོང། ',
    closeButton: 'སྒོ་རྒྱག། ',
    typeOuth: 'གཞན་དག། ',
    up: 'སྟེང་ཤོག་ངོས། ',
    courseInfo: 'སློབ་ཚན་ཞིབ་ཆ། ',
    requiredCourses: 'ངེས་པར་སྦྱོང་དགོས་པའི་སློབ་ཚན།',
    examResultPage: 'རྒྱུགས་ལེན་གྱི་མཇུག་འབྲས་ཤོག་ལྷེ། ',
    examPage: 'རྒྱུགས་ལེན་ཤོག་ལྷེ། ',
    noteSource: 'ཁྲོད་ནས་ཆགས་པར་བརྟེན་ལུགས་རྙིང། ',
    item: 'དོན་ཚན། ',
    cancelCollect: 'ཕྱིར་འཐེན་བསྡུ་ཉར། ',
    searchTips: 'ཁྱེད་ཀྱི་ཚད་སློབ་ཚན་མིང། ',
    count: 'ཁྱོན། ',
    courseExamination: 'ལྷན་ཕེབས་སློབ་ཚན་རྒྱུགས་ལེན། ',
    studentsNum: '选课མི་གྲངས། ',
    startExam: 'དགེ་རྒན་གྱི་ངོ་སྤྲོད་མདོར་བསྡུས། ',
    JoinLearning: 'འཛམ་གླིང་སློབ་སྦྱོང། ',
    publishButton: 'ཁྱབ་བསྒྲགས། ',
    uploadDate: 'ཡར་འཁོརདུས་ཚོད། ',
    typeDoc: 'ཡིག་ཚགས། ',
    resourceSize: 'ཐོན་ཁུངས་ཆེ་ཆུང། ',
    hotComment: 'ཆེས་དྲོ་བ། ',
    page: 'ཤོག་ངོས། ',
    collect: 'བསྡུ་ཉར། ',
    items: 'དོན་ཚན་/ཤོག་ངོས། ',
    evaluate: 'གདེང་འཇོག། ',
    isEvaluate: 'སྔར་ཡོད་ཀྱི་གདེང་འཇོག། ',
    cancelTips: 'ཡིན་མིན་ངེས་གཏན་མེད་པར་བསྡུ་ཉར། ',
    next: 'རྗེས་མའི་ཤོག་ངོས། ',
    preview: 'སྔོན་མང་པོ་ལྟ་བ། ',
    no: 'དོན་ཚན། ',
    chapter: 'ལེའུ། ',
    reExam: 'དགེ་རྒན་གྱི་ངོ་སྤྲོད་མདོར་བསྡུས། ',
    className: 'འཛིན་གྲྭ་འི་མིང། ',
    donwNum: 'ཁ་ཐེངས་གྲངས། ',
    confirmButton: 'མེད་པར་བཟོ་བ། ',
    courseEvaluate: 'སློབ་ཚན་ལ་གདེང་འཇོག། ',
    needIETips: 'མིག་སྔ་འི་སློབ་ཚན་ཁག་བཀོལ་དགོས་པ་IEལྟ་ཆས། ',
    times: 'ཐེངས། ',
    cancelButton: 'མེད་པར་བཟོ་བ། ',
    teachersDesc: 'དགེ་རྒན་གྱི་ངོ་སྤྲོད་མདོར་བསྡུས།',
    allCourses: 'ཡོངས་རྫོགས་སློབ་ཚན། ',
    commentTips: 'ཁྱེད་ཀྱི་ཚད་ལ་དཔྱད་གཏམ་བརྗོད་པའི་ནང་དོན། ',
    courseNote: 'སློབ་ཚན་ཟིན་ཐོ། ',
    man: 'མི། ',
    coursehours: 'སློབ་ཁྲིད་དུས་ཡུན། ',
    openComment: 'ང་དཔྱད་གཏམ། ',
    cancelConfirm: 'ཕྱིར་འཐེན་བསྡུ་ཉར། ',
    go: 'ལྡིང་ནས། ',
    typeImages: 'མང་བའི་པར་རིས། ',
    courseTeachers: 'དགེ་རྒན། ',
    typeViedo: 'བརྙན་འཕྲིན། ',
    courseHours: 'སློབ་ཚན་སློབ་ཁྲིད་དུས་ཡུན། ',
    marking: 'རྒྱུགས་དཔྱད་ཀྱི་ཁྲོད། ',
    electiveCourses: 'བདམས་སྦྱོང་སློབ་ཚན། ',
    deleteNoteButton: 'སུབ་པ། ',
    courseChapter: 'སློབ་ཚན་ལེའུ་དང། ',
    typeImage: 'པར་རིས། '
  },
  offlineclass: {
    evaluateTime: 'དཔྱད་དཔོག་དུས་ཚོད།',
    partySchool: 'ཏང་གི་སློབ་གྲྭ་འི་གསོ་སྦྱོང་འཛིན་གྲྭ།',
    seven: 'ཉིན། ',
    passedState: 'བརྒྱུད་དེ་རྣམ་པ།',
    sureDelete: 'ཁྱོད་ལ་ངོས་འཛིན་དགོས་སུབ་པ་ཨེ།',
    askLeave: 'ང་འི་དུས་ཚོད། ',
    three: 'གསུམ། ',
    photos: 'འདྲ་པར་ཉར་དེབ།',
    sickLeave: 'ནད་དགོངས། ',
    phontoRequier: 'འདྲ་པར་ངེས་པར་དུ་ལས་མ།',
    uploadPhoto: 'འདྲ་པར་ཐོག་བརྒྱུད་སྤྲོད། ',
    learningActivity: 'སློབ་སྦྱོང་བྱེད་སྒོ།',
    seeRecord: 'གཟིགས་ཞིབ་ཟིན་ཐོ།',
    leaveType: 'དུས་ཚོད་ཀྱི་རིགས་དབྱིབས། ',
    inputReasonLeave: 'ཁྱེད་ཀྱི་ཚད་དགོངས་ཞུ་འི་རྒྱུ་རྐྱེན། ',
    beDoing: 'ལ་སྐབས། ',
    classHours: 'འཛིན་གྲྭ་སློབ་ཁྲིད་དུས་ཡུན། ',
    five: 'ལྔ། ',
    notEvaluation: 'མ་དཔྱད་དཔོག།',
    reasonLeave: 'དགོངས་ཞུ་འི་རྒྱུ་རྐྱེན། ',
    inputPhotoName: 'ཁྱེད་ཀྱི་ཚད་འདྲ་པར་མིང། ',
    group: 'ཚོགས་ཆུང། ',
    leaveTime: 'དགོངས་ཞུ་འི་དུས་ཚོད། ',
    examPage: 'རྒྱུགས་ལེན་ཤོག་ལྷེ།',
    formatSupport: 'རྒྱབ་སྐྱོར་བྱེད་པའི་རྣམ་གཞག་དང་རྒྱབ་སྐྱོར། ',
    sure: 'གཏན་ཁེལ། ',
    resultPage: 'རྒྱུགས་ལེན་གྱི་མཇུག་འབྲས་ཤོག་ལྷེ།',
    saturdays: 'གཟའ་སྤེན་པ། ',
    selectTime: 'བསལ་འདེམས་ཀྱི་དུས་ཚོད། ',
    onlineToFace: 'ནི་ལས་གནས་གདོང་འཕྲད ',
    photoCategory: 'འདྲ་པར་ཉར་དེབ་རིགས་དབྱེ།',
    is: 'ནི།',
    startLearn: 'དེ་སློབ་སྦྱོང། ',
    firstWeek: '[1གཟའ་འཁོར། ',
    photoName: 'འདྲ་པར་གྱི་མིང། ',
    morning: 'སྔ་དྲོ་འི། ',
    sunday: 'གཟའ་ཉི་མ། ',
    at: 'ཟླ།',
    photoMessage: 'འདྲ་པར་ཆ་འཕྲིན། ',
    fullTimeToFace: 'ལས་བྲལ་གདོང་འཕྲད ',
    phoneIsOccur: 'འདྲ་པར་མིང་ཡོད་པ།',
    evaluating: 'དཔྱད་དཔོག། ',
    longNotBits: 'རིང་ཚད་ལས་བརྒལ་མི་ཆོག་50ཡིག་རྟགས།',
    hoursStandard: 'སློབ་སྦྱོང་དུས་མ་ཚད་ལོན་མིན་རྒྱུགས་སྤྲོད་ནང་ཞུགས།',
    evalueteNotStar: 'དཔྱད་དཔོག་མ་བཟུང།',
    submitFailure: 'རྒྱུགས་ཡིག་སྤྲོད་པ་ཕམ་ཁ།',
    examRecord: 'རྒྱུགས་ལེན་ཟིན་ཐོ། ',
    seeSubmite: 'གཟིགས་ཞིབ་རྒྱུགས་ཤོག།',
    questionnaire: 'བརྟག་དཔྱད་དྲི་ཤོག།',
    tickets: 'ཀྲང། ',
    submit: 'འབུལ།',
    for: 'བཞི།',
    notStarted: 'མ་བཟུང། ',
    coursesTaught: 'ལ་བསྐོས་པ་སློབ་ཚན།',
    notGroup: 'མའི་ཚོགས་ཆུང་ཁག་བགོས་ཀྱི། ',
    evaluateEnds: 'དཔྱད་དཔོག་དེ་མཇུག་འགྲིལ།',
    classEvaluation: 'འཛིན་གྲྭ་འི་དཔྱད་དཔོག། ',
    searchPartySchool: 'བཤེར་འཚོལ་ཁྱོད་ལ་སྤྲོ་སྣང་ཀྱི་ཏང་གི་སློབ་གྲྭ་འི་གསོ་སྦྱོང་འཛིན་གྲྭ།',
    two: 'གཉིས། ',
    fridays: 'གཟའ་པ་སངས། ',
    startEvaluation: 'ཐོག་མར་དཔྱད་དཔོག། ',
    isEvaluated: 'སྔར་ཡོད་ཀྱི་དཔྱད་དཔོག།',
    groupTalk: 'ཚོགས་ཆུང་ཁག་བགོས་ཀྱི་གྲོས་བསྡུར། ',
    openClass: 'སྒོ་འབྱེད་འཛིན་གྲྭ། ',
    not: 'དགག་པ་འི།',
    teacherAbout: 'དགེ་རྒན་གྱི་ངོ་སྤྲོད་མདོར་བསྡུས། ',
    addPhoneTips: 'གསར་དུ་ལེགས་འགྲུབ་བྱུང་བ། རོགས་སྒུག་པ་ཞིབ་བཤེར།',
    phoneNameReq: 'འདྲ་པར་མིང་ཁག་ངེས་པར་དུ་འབྲི།',
    deleteSuccess: 'སུབ་པ་ལེགས་གྲུབ།',
    inputIdea: 'ཁྱེད་ཀྱི་ཚད་ཁྱོད་ཀྱི་བསམ་ཚུལ།',
    wednesday: 'གཟའ་ལྷག་པ། ',
    evaluationStartTime: 'དཔྱད་དཔོག་འགོ་ཚུགས་པའི་དུས་ཚོད། ',
    passed: 'བརྒྱུད།',
    casualLeave: 'དགོངས་ཞུ། ',
    monday: 'གཟའ་ཟླ་བ། ',
    six: 'དྲུག། ',
    one: 'གཅིག། ',
    h: 'སྐབས། ',
    selectLeaveType: 'ཁྱེད་ཀྱི་བསལ་འདེམས་ཀྱི་དུས་ཚོད་དང་རིགས་དབྱིབས། ',
    clear: 'སྟོང་པ། ',
    thursday: 'གཟའ་ཕུར་བུ། ',
    selctLeaveTime: 'ཁྱེད་ཀྱི་བསལ་འདེམས་ཀྱི་དུས་ཚོད་དང་དུས་ཚོད། ',
    inputEvaluating: 'ཁྱེད་ཀྱི་ཚད་དང་དཔྱད་དཔོག་ནང་དོན། ',
    addPhoto: 'གསར་སྣོན་བྱས་པའི་འདྲ་པར།',
    afternoon: 'ཕྱི་དྲོ། ',
    courseEvaluation: 'སློབ་ཁྲིད་ཀྱི་དཔྱད་དཔོག། ',
    seeEvalute: 'ལྟ་ཞིབ་དཔྱད་དཔོག།',
    tuesday: 'གཟའ་མིག་དམར། ',
    teacherTech: 'ལ་ཐེབས་པའི་སློབ་ཚན། ',
    searchThoseClass: 'བཤེར་འཚོལ་ཁྱོད་ལ་སྤྲོ་སྣང་ངོས་བསྐོས་པའི་གསོ་སྦྱོང་འཛིན་གྲྭ།',
    allClass: 'ཡོངས་རྫོགས་འཛིན་གྲྭ། ',
    evening: 'དགོང་མོ། ',
    sketch: 'མ་ཕྱི།',
    evaluationInProgress: 'དཔྱད་ལ་ནང། '
  },
  onlineclass: {
    classSchedule: 'སློབ་ཚན་རེའུ་མིག',
    notBeginClass: 'མ་སློབ་འགོ་ཚུགས་པ། ',
    reason: 'རྒྱུ་མཚན།',
    upload: 'ཐོག་བརྒྱུད་སྤྲོད། ',
    downloadHomework: 'ཁ་ལས་བྱ། ',
    myScore: 'ང་ཐོབ་སྐར། ',
    videos: 'བརྙན་འཕྲིན། ',
    score: 'ཐོབ་སྐར། ',
    approved: 'ཞིབ་བཤེར་བྱས་པ་བརྒྱུད། ',
    elective: 'བདམས་སྦྱོང། ',
    multiImages: 'མང་བའི་པར་རིས། ',
    endClass: 'དེ་མཇུག་གྲིལ་བའི་འཛིན་གྲྭ། ',
    participating: 'ཞུགས། ',
    hideAllMan: '收起ཡོངས་རྫོགས་སློབ་མ།',
    cacheSave: 'གནས་སྐབས་བཅོལ་བ། ',
    formatSupport: 'ཡིག་ཆ་འི་རྣམ་གཞག་དང་རྒྱབ་སྐྱོར། ',
    images: 'པར་རིས། ',
    examIsPass: 'རྒྱུགས་ལེན་ཡོད་མེད་ལ་བརྟེན་ནས། ',
    subjectsNumber: 'སྒོ་གྲངས། ',
    startLearn: 'འདི་ཉིད་འཛིན་གྲྭ། ',
    classNotStar: 'འཛིན་གྲྭ་འི་ཐོ་འགོད་བྱས་མེད་པ་ས།',
    classTalk: 'འཛིན་གྲྭ་འི་གྲོས་སྡུར། ',
    nopassed: 'ད་དུང་མིང་ཐོ་འགོད་པར་བརྟེན་ནས།',
    leaveMaxBits: 'དགོངས་ཞུ་འི་རྒྱུ་རྐྱེན་ཆེས་མང་པོ་ལས་བརྒལ་མི་ཆོག་100ཡི་གེ།',
    submitTime: 'ཕུལ་བའི་དུས་ཚོད། ',
    trainingTime: 'གསོ་སྦྱོང་གི་དུས་ཚོད། ',
    notApproved: 'མ་ཞིབ་བཤེར། ',
    even: 'དགོང་མོ། ',
    classStudy: 'འཛིན་གྲྭ་འི་སློབ་སྦྱོང། ',
    resourceSize: 'ཐོན་ཁུངས་ཆེ་ཆུང། ',
    detail: 'ཞིབ་ཆ། ',
    downloadCount: 'ཁ་ཚད། ',
    electiveStandard: 'བདམས་སྦྱོང་ཚད་ལོན་སློབ་ཁྲིད་དུས་ཡུན། ',
    clickHere: 'དེ་མཚུངས་འདིར། ',
    onlineClasses: 'དྲ་ཐོག་ཆེད་དོན་འཛིན་གྲྭ།',
    quantityOfCourses: 'སློབ་ཚན་ཁ་གྲངས། ',
    document: 'ཡིག་ཚགས། ',
    compulsoryNumber: 'ངེས་པར་སྦྱོང་དགོས་པ་བརྒྱུད་ནས་གྲངས་ཚད། ',
    handed: 'རྒྱུགས་ཡིག་སྤྲོད་པ། ',
    hot: 'ཆེས་དྲོ་བ། ',
    inputTalkContent: 'ཁྱེད་ཀྱི་ཚད་ལ་གྲོས་བསྡུར་བྱེད་པའི་ནང་དོན།',
    groupTalk: 'ཚོགས་ཆུང་གྲོས་བསྡུར། ',
    openReservation: 'སྒོ་འབྱེད་མིང་ཐོ་འགོད་པ། ',
    noon: 'ཕྱི་དྲོ',
    clickReset: 'དེ་མཚུངས་གཅུས་སྒོ། ཕྱིར་འཐེན་མིང་ཐོ་འགོད་པ།',
    notSubmit: 'མ་ཕུལ་བ། ',
    leaveNotEndTime: 'དགོངས་ཞུ་འགོ་ཚུགས་པའི་དུས་ཚོད་མི་མཚུངས་པ་མཇུག་བསྒྲིལ་བའི་དུས་ཚོད།',
    inforCertificate: 'ལག་ཁྱེར། ',
    close: 'སྒོ་རྒྱག།',
    submitHomework: 'ཕུལ་བའི་ལས་བྱ། ',
    allTheClass: 'ཡོངས་རྫོགས་འཛིན་གྲྭ། ',
    address: 'གནས་ཡུལ།',
    homework: 'ལས་བྱ།',
    subjects: 'སྒོ། ',
    classOvered: 'འཛིན་གྲྭ་དེ་མཇུག་གྲིལ་བའི་འཛིན་གྲྭ།',
    agentRegister: 'ཡང་བསྐྱར་མིང་ཐོ་འགོད་པ།',
    updateTime: 'ཡར་འཁོརདུས་ཚོད། ',
    sizeNot: 'ཆེ་ཆུང་ལས་བརྒལ་མི་ཆོག།',
    showAllGroup: 'གཟིགས་ཞིབ་ཚང་མ་ཁོངས་མི།',
    searchThoseClass: 'བཤེར་འཚོལ་ཁྱོད་ལ་སྤྲོ་སྣང་དྲ་ཐོག་ཆེད་དོན་འཛིན་གྲྭ། ',
    groupMan: 'ཙུའུ་ཀྲང།',
    reSubmit: 'བསྐྱར་དུ་འབུལ། ',
    subjectsClass: 'སློབ་ཚན། ',
    to: 'ནས། ',
    submited: 'དེ་ཕུལ་བ། ',
    resourceType: 'རིགས་དབྱིབས། ',
    registrationTime: 'མིང་ཐོ་འགོད་པའི་དུས་ཚོད། ',
    numberOfParticipants: 'མིང་ཐོ་འགོད་མཁན་མི་གྲངས། ',
    cancelRegister: 'ཕྱིར་འཐེན་མིང་ཐོ་འགོད་པ།',
    excellence: 'ཕུལ་བྱུང། ',
    source: 'དཔྱད་ཡིག། ',
    compulsoryStandard: 'ངེས་པར་སྦྱོང་དགོས་པ་ཚད་ལོན་སློབ་ཁྲིད་དུས་ཡུན། ',
    iknow: 'ང་ས་ཤེས་ཐལ། ',
    down: 'འོག།',
    download: 'ཁ་། ',
    startExim: 'ཐོག་མར་རྒྱུགས་ལེན། ',
    electiveNumber: 'བདམས་སྦྱོང་བརྒྱུད་ནས་གྲངས་ཚད།',
    talk: 'གྲོས་བསྡུར། ',
    up: 'སྟེང།',
    communication: 'འཕྲིན་གཏོང། ',
    reply: 'བརྡ་ལན།',
    inputReason: 'ཁྱེད་ཀྱི་ཚད་ཕྱིར་འཐེན་བྱེད་པའི་རྒྱུ་རྐྱེན།',
    others: 'གཞན་དག། ',
    faceCourseClass: 'གདོང་འཕྲདགསོ་སྦྱོང་འཛིན་གྲྭ། ',
    hideAllGroup: '收起ཚང་མ་ཁོངས་མི།',
    courses: 'སློབ་ཚན། ',
    new: 'ཆེས་གསར་བ་འི། ',
    resource: 'ཐོན་ཁུངས། ',
    cancelLike: 'མེད་པར་གནས་བསྟོད།',
    classIsEnd: 'འཛིན་གྲྭ་འི་མིང་ཐོ་འགོད་མཁན་དེ་མཇུག་འགྲིལ།',
    delete: 'སུབ་པ། ',
    resetRegister: 'ཕྱིར་འཐེན་བྱ་རྒྱུ་འི་ཐོ་འགོད། ',
    classExam: 'འཛིན་གྲྭ་འི་རྒྱུགས་ལེན།',
    undo: 'མེད་པར་བཟོ་བ། ',
    teacher: 'དགེ་རྒན།',
    showAllMan: 'གཟིགས་ཞིབ་ཡོངས་རྫོགས་སློབ་མ།',
    noIntroduction: 'གནས་སྐབས་མེད་མཚམས་སྦྱོར་མདོར་བསྡུས།',
    notParticipat: 'ཞུགས་མེད་པ་འི།',
    allType: 'ཡོངས་རྫོགས་ཀྱི་རིགས་དབྱིབས། ',
    uploadHomework: 'ཡར་འཁོརལས་བྱ། ',
    notice: 'བརྡ་ཐོ། ',
    comments: 'དཔྱད་གཏམ། ',
    isDelete: 'ཡོད་མེད་ངོས་འཛིན་སུབ་པ། ',
    registerNow: 'འཕྲལ་མར་མིང་ཐོ་འགོད་པ།',
    classPassIndicator: 'འཛིན་གྲྭ་འི་ཐོག་གྲོས་འཆམ་བྱུང་བའི་དམིགས་ཚད།',
    compulsory: 'ངེས་པར་སྦྱོང་དགོས་པ། ',
    beginClass: 'ཟིན་པ་དང་སློབ་འགོ་ཚུགས་པ། ',
    allClass: 'ཚང་མ། ',
    publish: 'ཁྱབ་བསྒྲགས། ',
    talkTech: 'འཆད་འཁྲིད་དགེ་རྒན།',
    wantTalk: 'ང་ས་གྲོས་བསྡུར། ',
    Learned: 'དེ་སློབ་སྦྱོང། ',
    category: 'རིགས་དབྱེ། '
  },
  source: {
    classResource: 'འཛིན་གྲྭ་འི་ཐོན་ཁུངས། ',
    searchResource: 'བཤེར་འཚོལ་ཁྱོད་ལ་སྤྲོ་སྣང་ཐོན་ཁུངས། ',
    previewResource: 'ཐོན་ཁུངས་སྔོན་མང་པོ་ལྟ་བ།',
    evaluationSuccess: 'གདེང་འཇོག་ལེགས་གྲུབ།',
    allResource: 'ཚང་མའི་ཐོན་ཁུངས། ',
    commonResource: 'སྤྱི་སྤྱོད་ཐོན་ཁུངས། ',
    className: 'འཛིན་གྲྭ་འི་མིང།',
    resourceTalk: 'ཐོན་ཁུངས་ལ་གདེང་འཇོག།',
    resourceEvaluation: 'ཐོན་ཁུངས་ལ་དཔྱད་བརྗོད།',
    resourceCategory: 'ཐོན་ཁུངས་རིགས་དབྱེ། ',
    helpPoint: 'རོགས་རམ་ལག་དེབ།',
    isEvaluation: 'ཁྱེད་ཀྱིས་ཟིན་པའི་གདེང་འཇོག་བྱས་མྱོང་།',
    selectEvaluation: 'ཁྱེད་ཀྱིས་མ་བསལ་འདེམས་ཀྱི་དཔྱད་བརྗོད།',
    topRelise: 'གཅོད་ཀྱི་མདུན།'
  },
  login: {
    cancel: 'མེད་པར་བཟོ་བ། ',
    resetPassword: 'བསྐྱར་གཅོད་ཀྱི་གསང་བ།',
    newPhoneFomat: 'གསར་པ་ལག་ཐོགས་ཁ་པར་གྱི་ཨང་གྲངས་རྣམ་གཞག་ཡང་དག་མིན་པ་འི།',
    continueLogin: 'བསྐྱར་དུ་ཐོ་འགོད།',
    passwordBits: 'གསང་བའི་རིང་ཐུང་མི་ཆུང་6། ',
    forgetPassword: 'བརྗེད་ཨང་ཡིག།',
    sign: 'ཐོ་འགོད།',
    resetLoginTips: 'ཁྱེད་ནི་བཟོ་བཅོས་ཨང་ཡིག་ལེགས་གྲུབ་བྱ་རྒྱུ་ར་བསྐྱར་དུ་ཐོ་འགོད3སྐར་ཆ་རྗེས་རང་འགུལ་ངང།',
    captchaFail: 'ཚོད་ལྟ་ས་ར་སྤྲོད་དང་བར་ཞུ་དག་ཞིབ་བཤེར་ཕམ་ཁ།',
    newPhone: 'གསར་པ་ལག་ཐོགས་ཁ་པར་གྱི་ཨང་གྲངས།',
    logout: 'འཛེགས་པ་ལས་རྣམ་པར་རྒྱལ་བ་འི།',
    changePhone: 'བཟོ་བཅོས་ལག་ཐོགས་ཁ་པར་གྱི་ཨང་གྲངས།',
    accountNotEmpty: 'རྩིས་ཐོའི་ཨང་གྲངས་དེ་སྟོང། ',
    prevStep: 'སྟེང་གོམ་པ་གཅིག།',
    poor: 'ཞན།',
    incorrectTips: 'སྤྱོད་མཁན་མིང་འམ་གསང་བ་ནང་འདྲེན་ནོར་འཁྲུལ། ',
    surePasswordEmpty: 'དངོས་སུ་ཁས་ལེན་པའི་གསང་བ་དེ་སྟོང།',
    orgPhoneEmpty: 'ཐོག་མའི་ལག་ཐོགས་ཁ་པར་གྱི་ཨང་གྲངས་དེ་སྟོང།',
    inputNewPassowrd: 'ཁྱེད་ཀྱི་ཚད་གསར་པ་ཨང་ཡིག།',
    rightMessageChange: 'ཁྱོ་ས་ཕྱོགས་སྟོན་ལན་ཀན་གཡས་ལོགས་སུ་ཉལ་བའི་མི་སྒེར་གྱི་ཆ་འཕྲིན་ཁྲུའུ་བཟོ་བཅོས།',
    inputAccount: 'ཁྱེད་ཀྱི་ཚད་རྩིས་ཐོའི་ཨང་གྲངས།',
    inputPassword: 'ཁྱེད་ཀྱི་ཚད་ཨང་ཡིག།',
    captchaNotEmpty: 'ཚོད་ལྟ་ས་ར་སྤྲོད་མ་དེ་སྟོང། ',
    newPhoneSupport: 'གསར་པ་ལག་ཐོགས་ཁ་པར་གྱི་ཨང་གྲངས་མི་ཐུབ་པའི་དེ་སྔ་འི་ལག་ཐོགས་ཁ་པར་གྱི་ཨང་གྲངས་གཅིག་མཐུན།',
    phoneCaptchaEmpty: 'ལག་ཐོགས་ཁ་པར་ཚོད་ལྟ་ས་ར་སྤྲོད་མ་དེ་སྟོང།',
    sure: 'གཏན་ཁེལ། ',
    resetSuccessTips: 'ཁྱེད་ནི་ལྕི་གཅོད་ཨང་ཡིག་ལེགས་གྲུབ་བྱོས་ར་ཕེབས་ནས་ཐོ་འགོད།',
    copyRight: 'པར་དབང་ནི་×××××××××ལ་Copyright@2020པེ་ཅིན་ICPཐོ་འགོད། ',
    phoneEmpty: 'ལག་ཐོགས་ཁ་པར་གྱི་ཨང་གྲངས་དེ་སྟོང།',
    confimPassword: 'ཁྱེད་ཀྱི་ངོས་འཛིན་ཨང་ཡིག།',
    inputOrigPassword: 'ཁྱེད་ཀྱི་ཚད་ཐོག་མའི་གསང་བ།',
    phoneNumber: 'ལག་ཐོགས་ཁ་པར་གྱི་ཨང་གྲངས། ',
    nextStep: 'གོམ་སྟབས་རྗེས་མ་འི།',
    reset: 'བསྐྱར་གཅོད།',
    surePassword: 'ཁྱེད་ཀྱི་ངོས་འཛིན་ཨང་ཡིག།',
    formerPhone: 'ཐོག་མའི་ལག་ཐོགས་ཁ་པར་གྱི་ཨང་གྲངས།',
    clickGoHome: 'དེ་མཚུངས་ཀྱི་ཕྱིར་ཐོ་འགོདཤོག་ངོས།',
    loginNow: 'འཕྲལ་མར་འཛེག།',
    strong: 'ཆེ་བ།',
    confirmNot: 'ལས་འབྲི་གསང་བ་དང་ངོས་འཛིན་གསང་ཨང་གཅིག་གྱུར་མིན་པ། ',
    changePasswordSuccess: 'བཟོ་བཅོས་ཨང་ཡིག་ལེགས་གྲུབ།',
    inputUserName: 'ཁྱེད་ཀྱི་ཚད་སྤྱོད་མཁན་མིང་།',
    failTips: 'ཞུ་དག་ཞིབ་བཤེར་ཕམ་ཁ།',
    changePhoneSuccess: 'བཟོ་བཅོས་ལག་ཐོགས་ཁ་པར་གྱི་ཨང་གྲངས་ལེགས་གྲུབ།',
    orgPhoneFormat: 'ཐོག་མའི་ལག་ཐོགས་ཁ་པར་གྱི་ཨང་གྲངས་རྣམ་གཞག་ཡང་དག་མིན་པ་འི།',
    newPhoneBinded: 'གསར་པ་ལག་ཐོགས་ཁ་པར་གྱི་ཨང་གྲངས་ཟིན་པ་མགོ་སྦྲེལ།',
    passwordBitsLong: 'གསང་བའི་རིང་ཐུང་མི་ལས་ཆེ་བ་18གནས། ',
    loginFail: 'ཐོ་འགོདཕམ་ཁ་ཁྱེད་ལ་མཐོང་ཆེན་དང་ཚོད་ལྟ་བྱེད་པ།',
    bingPhone: 'མགོ་སྦྲེལལག་ཐོགས་ཁ་པར་གྱི་ཨང་གྲངས།',
    accountVerif: 'རྩིས་ཐོའི་ཨང་གྲངས་ཚོད་ལྟ་ས་ར་སྤྲོད།',
    userNameEmpty: 'སྤྱོད་མཁན་མིང་དེ་སྟོང།',
    bingPhoneSuccess: 'མགོ་སྦྲེལལག་ཐོགས་ཁ་པར་གྱི་ཨང་གྲངས་ལེགས་གྲུབ།',
    onlineTraining: 'ལིའོ་རྒྱལ་རབས་མཐོ་eསློབ་གླིང་དེ་གསོ་སྦྱོང་ལས་སྟེགས། ',
    middle: 'ནང།',
    newPhoneEmpty: 'བཟོ་བཅོས་ལག་ཐོགས་ཁ་པར་གྱི་ཨང་གྲངས།',
    goHome: 'སྣེ་འཁྲིད་ཤོག་ལྷེ་དང་པོ།',
    resetDone: 'བསྐྱར་གཅོད་ལེགས་གྲུབ།',
    inputCaptcha: 'ཁྱེད་ཀྱི་ཚད་ཚོད་ལྟ་ས་ར་སྤྲོད་མ།',
    phoneBinded: 'ལག་ཐོགས་ཁ་པར་གྱི་ཨང་གྲངས་ཟིན་པ་མགོ་སྦྲེལ།',
    changePhoneSuccessTips: 'ཁྱེད་ནི་བཟོ་བཅོས་ལག་ཐོགས་ཁ་པར་གྱི་ཨང་གྲངས་ལེགས་གྲུབ།',
    phoneFormat: 'ལག་ཐོགས་ཁ་པར་གྱི་ཨང་གྲངས་རྣམ་གཞག་ཡང་དག་མིན་པ་འི།',
    captchaTips: 'ཚོད་ལྟ་ས་ར་སྤྲོད་མ་བྱས་ནས་ནང་འདྲེན་ནོར་འཁྲུལ། ',
    changePassword: 'བཟོ་བཅོས་ཨང་ཡིག།',
    phoneVerif: 'ལག་ཐོགས་ཁ་པར་ཚོད་ལྟ་ས་ར་སྤྲོད།',
    passwordFormat: 'གསང་བའི་རིང་ཚད་8ནས་32། འདུས་པའི་གྲངས་ཀ་དང་འབྲི་བྲིས་ཆེན་པོཡི་གེ།',
    passwordNotEmpty: 'གསང་བ་དེ་སྟོང། ',
    getCaptcha: 'ལག་སོན་ཚོད་ལྟ་ས་ར་སྤྲོད་མ།',
    orgPhoneNot: 'ཐོག་མའི་ལག་ཐོགས་ཁ་པར་གྱི་ཨང་གྲངས་ཡང་དག་མིན་པ་འི།',
    msgCaptcha: 'འཕྲིན་ཐུང་ཚོད་ལྟ་ས་ར་སྤྲོད་མ།',
    resetSuccess: 'བསྐྱར་གཅོད་ལེགས་གྲུབ།',
    loginVertif: 'ཐོ་འགོདཚོད་ལྟ་ས་ར་སྤྲོད།'
  },
  usercenter: {
    onBusiness: 'གཞུང་དོན། ',
    loginAccount: 'ཐོ་འགོདརྩིས་ཐོའི་ཨང་གྲངས། ',
    practice: 'གཤར་སྦྱང། ',
    courseCollected: 'སློབ་ཚན་བསྡུ་ཉར། ',
    chargeInfo: 'རིན་བསྡུ་འི་ཚད་གཞི། ',
    deleCourse: 'གཏན་འཁེལ་དེ་ལ་སློབ་ཚན།',
    year: 'ལོ་འཁོར། ',
    onlineCentralizedLearning: 'ནི་ཐིག་གཅིག་སྡུད་སློབ་སྦྱོང། ',
    otherOptionTips: 'ཁྱེད་ཀྱི་ནང་འདྲེན་བྱེད་དགོས་པའི་ཁ་གསབ་གཞན་དག་གི་དོན་དག། ',
    onExam: 'རྒྱུགས་ལེན་ལ་ནང། ',
    myScore: 'ང་ཐོབ་སྐར། ',
    allHours: 'སྤྱིའི་སློབ་ཁྲིད་དུས་ཡུན། ',
    noStartLearn: 'སློབ་སྦྱོང་བྱེད་འགོ་བརྩམས་མེད།',
    phoneWrong: 'ཁྱེད་ཀྱི་ཚད་ཡང་དག་པའི་ལག་ཐོགས་ཁ་པར་གྱི་ཨང་གྲངས། ',
    confirmHandExams: 'ཡོད་མེད་ངོས་འཛིན་རྒྱུགས་ཡིག་སྤྲོད་པ། ',
    goBackrecommend: 'ཕྱིར་དགེ་རྒན་འོས་སྦྱོར། ',
    score: 'སྐར་མ། ',
    emptyAnswer: '选项འམ་ལན་འདེབསནང་དོན་དེ་སྟོང། ',
    ongoing: 'ལ་ནང། ',
    editTeacher: 'རྩོམ་སྒྲིག་པ། ',
    myQuestionnaire: 'ང་འི་དྲི་ཤོག། ',
    english: 'དབྱིན་ཡིག། ',
    faceCourse: 'གདོང་འཕྲདའཛིན་གྲྭ། ',
    requiredCourses: 'ངེས་པར་སྦྱོང་དགོས་པའི་སློབ་ཚན། ',
    cancelLeave: 'ཕྱིར་འཐེན་བྱ་རྒྱུ་འི་དུས་ཚོད། ',
    wrongQuestionBank: 'ང་འི་ནོར་ཁ་བྱང་། ',
    allTeacher: 'དགེ་རྒན་ཡོངས་ཀྱི། ',
    workUnit: 'ལས་གནས་སྡེ་ཚན། ',
    otherInfo: 'གཞན་གྱི་ཆ་འཕྲིན། ',
    passedCourse: 'དེ། ',
    onlineSelfLearn: 'རང་བདག་གིས་ཐིག་སློབ་སྦྱོང། ',
    ruleString: 'ཁྱེད་ཀྱི་ཚད་80གནས་（དེའི་ནང་80）ནང་ཡིག་རྟགས། ',
    inExams: 'ཡིག་རྒྱུགས། ',
    personal: 'རྐྱེན་གྱིས་ལྐོག་ཏུ། ',
    completed: 'དེ་བསླབས་ཚར། ',
    confirmCancel: 'ངེས་གཏན་མིན་དེ་ཉིད་ཕྱིར་འཐེན་བྱ་རྒྱུ་འི་དུས་ཚོད། ',
    checkTeacher: 'གཟིགས་ཞིབ།',
    rejectReasons: 'སུན་འབྱིན་རྒྱུ་རྐྱེན། ',
    junior: 'དམའ་འབྲིང་སློབ་མ་འི། ',
    passedExam: 'རྒྱུགས་ལེན་དེ། ',
    exam: 'རྒྱུགས་ལེན། ',
    myCollected: 'ང་བསྡུ་ཉར། ',
    fitBusiness: 'མཐུན་པའི་ལས་སྒོ་འི་ཐིག། ',
    assessmentTime: 'དཔྱད་ཞིབ་བྱེད་པའི་དུས་ཚོད། ',
    handExamsSuccess: 'རྒྱུགས་ཡིག་སྤྲོད་པ་ལེགས་གྲུབ། ',
    allCertificate: 'ཡོངས་རྫོགས་ལག་ཁྱེར། ',
    outCompanyLearnHours: 'ཕྱི་འི་སྡེ་ཚན་གྱི་སློབ་སྦྱོང་（སློབ་ཁྲིད་དུས་ཡུན་）། ',
    deleteCollected: 'སྤོས་རྣམས་བསྡུ་ཉར། ',
    searchWrongTips: 'བཤེར་འཚོལ་ཁྱོད་ལ་སྤྲོ་སྣང་འཛོལ་འདྲི་གཞི། ',
    teachingStyle: 'སློབ་ཁྲིད་ཀྱི་ཉམས་འགྱུར། ',
    baseInfo: 'རྨང་གཞི་འི་ཆ་འཕྲིན། ',
    searchExamTips: 'ནང་འདྲེན་བཤེར་འཚོལ་མིང། ',
    eachQuestion: 'རེ་འབྲི། ',
    hasCollected: 'དེ་བསྡུ་ཉར། ',
    surplusMakeUpExam: 'ལྷག་མ་ཟུར་རྒྱུགས་ལེན་པ། ',
    cancelTitle: 'ཕྱིར་འཐེན་བྱ་རྒྱུ་འི་ངོས་འཛིན། ',
    teacherNameTips: 'ཁྱེད་ཀྱི་ནང་འདྲེན་བྱས་ནས་དགེ་རྒན་གྱི་རུས་མིང། ',
    underway: 'ཁྱོད་བཞིན། ',
    searchLeaveTips: 'བཤེར་འཚོལ་ཁྱོད་ལ་སྤྲོ་སྣང་འི་དུས་ཚོད། ',
    teacherInfo: 'མི་སྒེར་གྱི་ཆ་འཕྲིན། ',
    recommendTeacher: 'དགེ་རྒན་གྱིས་འོས་སྦྱོར། ',
    teacherLocationTips: 'ཁྱེད་ཀྱི་ཚད་རྒྱུན་སྡོད་བྱེད་ས།',
    fitLevelTips: 'ཁྱེད་ཀྱི་བསལ་འདེམས་དང་འཚམས་པའི་སློབ་ཁྲིད་བྱ་ཡུལ་གྱི་རིམ་པ། ',
    pauseSuccess: 'གནས་སྐབས་བཅོལ་བ་ལེགས་གྲུབ། ',
    faceOutProduceHours: 'གདོང་འཕྲདལས་བྲལ་（སློབ་ཁྲིད་དུས་ཡུན་）། ',
    auditDate: 'རེ་ཞུ་འི་དུས་ཚོད། ',
    teachingExpertiseTips: 'ཁྱེད་ཀྱི་ཚད་དགེ་རྒན་གྱི་སློབ་ཁྲིད་ཡོན་ཏན། ',
    failedCourse: 'མ་བརྒྱུད། ',
    yourScore: 'ཁྱེད་ཀྱི་ཐོབ་སྐར། ',
    question: 'ཁ་བྱང། ',
    teacherName: 'དགེ་རྒན་གྱི་རུས་མིང། ',
    needAudit: 'མྱུར་དུ་ཞིབ་བཤེར། ',
    faceTrain: 'གདོང་འཕྲདགསོ་སྦྱོང། ',
    welcomeMessage: 'ཁྱེད་རང་ཁམས་དྭངས་བར་དགའ་རེ། ',
    addTeachers: 'གསར་སྣོན་བྱས་པའི་དགེ་རྒན། ',
    checkInfo: 'གཟིགས་ཞིབ་ཞིབ་ཆ། ',
    assessmentStatus: 'དཔྱད་ཞིབ་བྱེད་པའི་རྣམ་པ། ',
    learningArchives: 'སློབ་སྦྱོང་གི་ཡིག་ཚགས། ',
    schoolLeader: '校领导། ',
    myExams: 'ང་འི་རྒྱུགས་ལེན། ',
    auditMessage: 'ཞིབ་མཆན་འགོད་པའི་རྒྱུ་རྐྱེན། ',
    otherOption: 'གཞན་གྱི་དོན་དག། ',
    386: 'སློབ་སྦྱོང་གི་ཡིག་ཚགས། ',
    noPublicAnswers: 'ཐེངས་འདི་ཡིག་རྒྱུགས་ཁྱབ་བསྒྲགས་མི་ལན། ',
    examCollected: 'རྒྱུགས་གཞི། ',
    electiveCourses: 'བདམས་སྦྱོང་སློབ་ཚན། ',
    teacherDescTips: 'ཁྱེད་ཀྱི་ཚད་དགེ་རྒན་ངོ་སྤྲོད་མདོར་བསྡུས། ',
    currentState: 'མིག་སྔ་འི་རྣམ་པ། ',
    examExplain: 'རྒྱུགས་ལེན་གསལ་བཤད། ',
    noPublicResult: 'ཐེངས་འདི་འི་རྒྱུགས་ལེན་པའི་ཁྱབ་བསྒྲགས་མི། ',
    examLog: 'རྒྱུགས་ལེན་ཟིན་ཐོ། ',
    notFaceOutProduceHours: 'མ་ཡིན་པའི་ལས་བྲལ་གདོང་འཕྲད（སློབ་ཁྲིད་དུས་ཡུན་）། ',
    searchQuestionnaireTips: 'ནང་འདྲེན་བཤེར་འཚོལ་དྲི་ཤོག་མིང། ',
    fitLevel: 'མཐུན་པའི་སློབ་ཁྲིད་བྱ་ཡུལ་གྱི་རིམ་པ། ',
    newTeacher: 'གསར་སྣོན་བྱས་པའི་དགེ་རྒན། ',
    allLeave: 'ཚང་མའི་དུས་ཚོད། ',
    noticeSearchTips: 'བཤེར་འཚོལ་ཁྱོད་ལ་སྤྲོ་སྣང་གསར་འགྱུར། ',
    htllo: 'ཁྱོད་བདེ་མོ། ',
    learningExperience: 'སློབ་སྦྱོང་གི་ལོ་རྒྱུས། ',
    empty: 'མེད་པ། ',
    recommendUnit: 'འོས་སྦྱོར་སྡེ་ཚན། ',
    leaveState: 'མིག་སྔ་འི་རྣམ་པ། ',
    makeUpExam: 'དེ་རྗེས་ཟུར་རྒྱུགས་ལེན་པ། ',
    contact: 'འབྲེལ་གཏུག་བྱེད་སྟངས། ',
    recommendSuccessTips: 'ཁྱེད་ནི་ལེགས་འགྲུབ་འབུལ་འོས་སྦྱོར་བྱེད་པའི་དགེ་རྒན་ལ་ཞིབ་དཔྱད་གྲོས་འཆམ་བྱུང་རྗེས་དེའི་དགེ་རྒན་གྱིས་འཛམ་གླིང་དགེ་རྒན་མཛོད། ',
    startQuestionnaire: 'ཐོག་མར་བློ་ཡིད་འཚིམས་པ་འི། ',
    haveTime: 'ལྷག་མའི་དུས་ཚོད།',
    searchTeacherTips: 'བཤེར་འཚོལ་ཁྱོད་ལ་སྤྲོ་སྣང་དགེ་རྒན། ',
    all: 'ཚང་མ། ',
    teachingExpertise: 'སློབ་ཁྲིད་ཀྱི་ཡོན་ཏན། ',
    isRequired: 'ཐེངས་འདི་ར་འབྲི། ',
    myOnlineCourse: 'ང་འི་དྲ་ཐོག་ཆེད་དོན་འཛིན་གྲྭ། ',
    searchTips: 'ནང་འདྲེན་བཤེར་འཚོལ་སློབ་ཚན་མིང། ',
    rulePhone: 'ཁྱེད་ཀྱི་ཚད་ཡང་དག་པའི་ལག་ཐོགས་ཁ་པར་གྱི་ཨང་གྲངས། ',
    noExams: 'གནས་སྐབས་མེད་རྒྱུགས་ལེན། ',
    annualAssessment: 'ལོ་འི་ལོ་འཁོར་དཔྱད་ཞིབ། ',
    confirmDeleteTips: 'ཡོད་མེད་ངོས་འཛིན་སུབ་པ། ',
    pause: 'གནས་སྐབས་བཅོལ་བ། ',
    assessmentIndex: 'དཔྱད་ཞིབ་དམིགས་ཚད། ',
    myLeave: 'ང་འི་དུས་ཚོད། ',
    deleteWrongQuestion: 'སྤོས་རྣམས་ནོར་ཁ་བྱང་། ',
    autoSaveSuccess: 'རང་འགུལ་གྱིས་ཉར་འཛིན། ',
    name: 'རུས་མིང། ',
    isOver: 'དེ་མཇུག་འགྲིལ། ',
    myNotice: 'ང་འི་གནས་ཚུལ། ',
    myOrder: 'ང་འི་གནས་ཚུལ། ',
    workingIn: 'ལས་གནས་དེ། ',
    fitBusinessTips: 'ཁྱེད་ཀྱི་བསལ་འདེམས་ལ་འཚམ་པའི་ལས་སྒོ་འི་ཐིག། ',
    onlineCenterLearnHours: 'ནི་ཐིག་གཅིག་སྡུད་སློབ་སྦྱོང་（སློབ་ཁྲིད་དུས་ཡུན་）། ',
    myCourse: 'ང་འི་སློབ་ཚན། ',
    isCorrect: 'དེ་བཞིན་སེལ་བ། ',
    checkTeacherInfo: 'ལྟ་ཞིབ་དགེ་རྒན། ',
    myCertificate: 'ང་འི་ལག་ཁྱེར། ',
    onlineSelfLearnHours: 'ནི་ཐིག་རང་ཚུགས་ཀྱིས་སློབ་སྦྱོང་བྱེད་པའི་(སློབ་ཁྲིད་དུས་ཡུན་）། ',
    examHours: 'རྒྱུགས་ལེན་དུས་རིང་པོ། ',
    autoSaveFailed: 'རང་འགུལ་གྱིས་ཉར་འཛིན་ཕམ་ཁ།',
    saveFailed: 'ཉར་ཚགས་བྱེད།',
    student: 'སློབ་མ། ',
    mathematics: 'རྩིས་རིག། ',
    teacherContactTips: 'ཁྱེད་ཀྱི་ཚད་དགེ་རྒན་འབྲེལ་གཏུག་བྱེད་སྟངས། ',
    reExam: 'བསྐྱར་དུ་རྒྱུགས་ལེན། ',
    teacherWorkUnitTips: 'ཁྱེད་ཀྱི་ཚད་དུ་ལས་གནས་སྡེ་ཚན། ',
    teamLeader: 'ཚོ་ཆུང་དཔོན། ',
    delete: 'སུབ་པ། ',
    allExams: 'ཚང་མར་རྒྱུགས་ལེན། ',
    times: 'ཐེངས། ',
    cancelButton: 'ཕྱིར་འཐེན།',
    ruleIsNumber: 'ཁྱེད་ཀྱི་ཚད་ཨང་ཀི། ',
    allCourses: 'ཡོངས་རྫོགས་སློབ་ཚན། ',
    systemNotice: 'མ་ལག་དྲན་སྐུལ། ',
    learnTo: 'སློབ་སྦྱོང་བྱས་ནས། ',
    onlineCourse: 'དེ་ན་འཛིན་གྲྭ། ',
    questionnaireDate: 'དྲི་ཤོག་གི་དུས་ཚོད།',
    company: 'གནས་ས་འི་སྡེ་ཚན། ',
    searchFaceTips: 'བཤེར་འཚོལ་ཁྱོད་ལ་སྤྲོ་སྣང་སློབ་ཚན། ',
    teachingStyleTips: 'ཁྱེད་ཀྱི་ཚད་དགེ་རྒན་གྱིས་སློབ་ཁྲིད་བྱེད་པའི་ཉམས་འགྱུར། ',
    isCompleted: 'ལེགས་གྲུབ་ཟིན་པ། ',
    outCompanyLearn: 'ཕྱི་འི་སྡེ་ཚན་ལ་སློབ་སྦྱོང། ',
    hours: 'སྐབས། ',
    onlineLearning: 'ནི་ཐིག་སློབ་སྦྱོང། ',
    headmaster: 'འཛིན་གྲྭ་འི། ',
    ruleNumber: 'ཁྱེད་ཀྱི་ཚད་8(འདུས་བརྒྱད། ）ནང་རིལ། ',
    teachingInfo: 'སློབ་ཁྲིད་ཀྱི་ཆ་འཕྲིན། ',
    userName: 'སྤྱོད་མཁན་མིང་། ',
    message: '私信། ',
    confirmDelete: 'སུབ་པ་ངོས་འཛིན། ',
    chargeInfoTips: 'ཁྱེད་ཀྱི་ཚད་བསྡུ་བའི་ཚད་གཞི། ',
    searchOnlineTips: 'བཤེར་འཚོལ་ཁྱོད་ལ་སྤྲོ་སྣང་དྲ་ཐོག་ཆེད་དོན་འཛིན་གྲྭ། ',
    marking: 'རྒྱུགས་དཔྱད་ཀྱི་ཁྲོད། ',
    exams: 'རྒྱུགས་ལེན། ',
    myFaceCourse: 'ང་འི་ངོས་བསྐོས་པའི་གསོ་སྦྱོང་འཛིན་གྲྭ། ',
    highSchool: 'མཐོ་འབྲིང་གི་སློབ་མ། ',
    pleaseSelect: 'ཁྱེད་ཀྱི་བསལ་འདེམས། ',
    leaveInfo: 'དགོངས་ཞུ་ཞིབ་ཆ། ',
    location: 'རྒྱུན་སྡོད་བྱེད་ས། ',
    committeeMembers: 'རྩ་འཛུགས་སྒྲིག་ཁྲིམས་ཞིབ་བཤེར་ཨུ་ཡོན། ',
    examOver: 'རྒྱུགས་ལེན་དེ་མཇུག་འགྲིལ། ',
    checkQuestionnaire: 'ཕེབས་ཤོག། ',
    examsLog: 'རྒྱུགས་ལེན་ཟིན་ཐོ།'
  }
};